<template>
  <div class="border-b border-gray-200 my-6 sm:my-8 lg:my-12">
  </div>
</template>
